import { wishlistsApi } from "@capone/common";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, BoxProps, Typography } from "@material-ui/core";
import {
  wishlistManagementModalActions,
  WishlistHeartIconEntry,
} from "halifax";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./styles.module.scss";

interface IWishlistSearchEntryProps extends BoxProps {}

export const WishlistSearchEntry = ({
  ...boxProps
}: IWishlistSearchEntryProps) => {
  const dispatch = useDispatch();

  const hasWishlists = Boolean(
    useSelector(wishlistsApi.endpoints.getAllWishlists.select())?.data
      ?.wishlists?.length
  );

  return (
    <Box
      className={styles.wishlistSearchEntry}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      onClick={() => {
        dispatch(wishlistManagementModalActions.openModal({}));
      }}
      {...boxProps}
    >
      <Box display="flex" alignItems="center" style={{ gap: "10px" }}>
        <Box display="flex" height="20px" alignItems="center">
          <WishlistHeartIconEntry
            hasWishlists={hasWishlists}
            onClick={() => {}}
          />
        </Box>
        <Typography variant="h6" style={{ color: "#013D58" }}>
          Favorites
        </Typography>
      </Box>
      <FontAwesomeIcon icon={faChevronRight} color="#013D58" height="15px" />
    </Box>
  );
};
